/* Vereine, die den AFH Hub nutzen.
 *
 * Heute genau ein Eintrag. Ein zweiter Club soll hier nur ein weiterer
 * Listeneintrag sein — keine Codeänderung an AppHeader.vue oder anderer
 * Stelle. Siehe docs/rollen-konzept.md und docs/farbsystem-afh.md für den
 * Hintergrund der AFH-Umstellung.
 *
 * Diese Liste zieht in der nächsten Stufe in eine Tabelle `clubs` in der
 * Datenbank um.
 */
export const CLUBS = [
  { id: 'grassrunners', name: 'Grassrunners FC', crest: 'brand-mark.png', season: '26 / 27' },
];
